import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20beautifully%20illustrated%20manga%20comic%20page%20on%20screen%20with%20warm%20ambient%20lighting%2C%20minimalist%20setup%20on%20a%20clean%20desk%20with%20soft%20natural%20light%2C%20modern%20lifestyle%20product%20photography%20with%20artistic%20composition%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20quality&width=800&height=600&seq=app-section-mobile&orientation=landscape"
                alt="手机阅读漫画体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-3">
              移动优先
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {appData.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appData.description}
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
              {appData.features.map((feat, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-2 p-3 bg-background-50 rounded-xl"
                >
                  <div className="w-7 h-7 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-sm"></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                    {feat}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-read-line"></i>
                立即体验
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-medium border border-background-300 text-foreground-700 rounded-full hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}